import { useMutation } from 'react-query';
import request from '../../../../helpers/request';

const getTransportById = async (id) => {
  return await request.get(
    `HousingStock/transport/${id}`,
    {},
    'При получении ТС произошла ошибка',
    'Error'
  );
};

const useGetTransportById = () =>
  useMutation(getTransportById, {
    onSuccess: (data) => {
      if (data === 'Error') return;
    },
  });

export default useGetTransportById;
